import { withInstall } from '../../../../utils/with-install'
import WMS from './WMS.vue'

export const ElAmapLayerWms = withInstall(WMS)
export default ElAmapLayerWms
